import { render, staticRenderFns } from "./HeaderTest.vue?vue&type=template&id=2963d8d0&scoped=true"
var script = {}
import style0 from "./HeaderTest.vue?vue&type=style&index=0&id=2963d8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963d8d0",
  null
  
)

export default component.exports